module.exports = __webpack_public_path__ + "static/img/blue_02_179.67e844f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/teaser/deco/blue_02_179.png
// module id = y8M2
// module chunks = 0